<template>
    <div class="blocked-ip-container">
        <div class="blocked-ip-title">Erişiminiz Engellendi</div>
        <div class="blocked-ip-description">
            Bu sayfaya erişebilmek için, erişiminize izin veren özel bir ağda olduğunuzdan emin olun; bu durumda bir
            VPN'e bağlanmanız gerekebilir.
        </div>
        <div class="blocked-ip-suggestion">
            Alternatif olarak, bir yöneticiden IP adresinizi ({{ user.lastLoginIPAddress }}) izin verilenler listesine
            eklemesini isteyin.
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "BlockedIP",
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
};
</script>
<style lang="scss" scoped>
.blocked-ip-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 10px;
}
.blocked-ip-title {
    font-size: 24px;
    font-weight: 600;
}
.blocked-ip-description {
    font-size: 16px;
}
.blocked-ip-suggestion {
    font-size: 16px;
}
</style>
